import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Menu from '../components/Menu';
import { FaRegCalendarAlt, FaRegClock } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
    const { t, i18n } = useTranslation()

    return (
        <>
            <div className='main-content'>
                <Header page={""} title={t("Privacy Policy")} backpage={'/'} />
                <div className='padding2'>
                    <div className='container'>
                        <h4 className='fw-bold mb-3'>{t("Privacy Policy")}</h4>
                        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sed mollitia esse laboriosam animi molestias eaque nihil qui recusandae voluptas asperiores numquam velit ipsa, quaerat deserunt necessitatibus exercitationem fugiat, nisi aliquam?</p>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas beatae, dicta voluptate iure accusantium unde ipsam? Accusantium eveniet natus possimus, laboriosam illum sapiente iste! Maiores doloribus dignissimos dolorem explicabo tempora.</p>
                    </div>
                </div>
                <Menu />
            </div>
        </>
    );
};

export default PrivacyPolicy;
